if (!customElements.get('sticky-cta')) {
  customElements.define('sticky-cta', class StickyCTA extends HTMLElement {
    constructor() {
      super();
      this.targetButton = null;
      this.observer = null;
    }

    connectedCallback() {
      // Find the normal buy button to observe
      const section = this.closest('.section-product-page');
      this.targetButton = section?.querySelector('.product-form__submit');

      if (!this.targetButton) return;

      // Initialize Intersection Observer
      this.initializeObserver();
    }

    initializeObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          // If buy button is visible, hide sticky CTA
          // If buy button is not visible, show sticky CTA
          if (entry.isIntersecting) {
            this.classList.add('is-hidden');
          } else {
            this.classList.remove('is-hidden');
          }
        });
      }, options);

      this.observer.observe(this.targetButton);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  });
}
